import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import Header from '../components/Header';

export default function Newsletter() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch landing data for header menu items and cart quantity
    fetch('/api/landing')
      .then(async (res) => {
        const text = await res.text();
        return JSON.parse(text);
      })
      .then((json) => {
        console.log('✅ Newsletter page data:', json);
        setData(json);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching landing data:', err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress />
        <Typography ml={2}>Loading...</Typography>
      </Box>
    );
  }

  return (
    <>
      {/* Same Header as Landing Page */}
      <Header
        menuItems={Array.isArray(data?.menuItems) ? data.menuItems : []}
        logo="/images/mihu-logo-trans.png"
        cartQty={typeof data?.cartQty === 'number' ? data.cartQty : 0}
      />

      {/* Embedded Newsletter - adjusted for header height */}
      <Box
        sx={{
          width: '100vw',
          height: 'calc(100vh - 64px)', // Subtract header height (64px is typical AppBar height)
          marginTop: '64px', // Push content below header
          overflow: 'hidden'
        }}
      >
        <iframe
          src="https://wordsoundlife-berkeley-edu.apphost.ocf.berkeley.edu/newsletter9"
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
            margin: 0,
            padding: 0
          }}
          title="Newsletter"
          sandbox="allow-same-origin allow-scripts allow-forms"
        />
      </Box>
    </>
  );
}